// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__18YLy","loaderOuter":"PageOverlayLoader_loaderOuter__MDj-b"};